import './style.css';

export default function Botao({ text, onClick, style = 'btn' }) {
    return (
        <button className={style} onClick={onClick}>
            <span className='text'>{text}</span>
        </button>
    );
}
